import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
// Fontes auto-hospedadas (RNF-026): nenhuma requisição a CDN sai do painel.
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/jetbrains-mono/500.css';
import '@fontsource/jetbrains-mono/600.css';
import { ProvedorSessao } from './autenticacao/SessaoContexto.js';
import { router } from './app/routes.js';
import './styles/base.css';

const raiz = document.getElementById('root');

if (!raiz) {
  throw new Error('Elemento #root não encontrado em index.html.');
}

createRoot(raiz).render(
  <StrictMode>
    <ProvedorSessao>
      <RouterProvider router={router} />
    </ProvedorSessao>
  </StrictMode>,
);
